import React from 'react';
import {createStackNavigator} from '@react-navigation/stack';
import AppRoutes from 'src/AppRoutes';
import SnackDetailScreen from 'src/components/screens/sendSnack/SnackDetailScreen';
import ScanAccountScreen from 'src/components/screens/scanAccount/ScanAccountScreen';
import {RewardsTabScreenWithHOC} from 'src/components/screens/RewardsHOCScreen';
import NewMobileOrderLocationScreen from 'src/components/elements/rewards/NewMobileOrderLocationScreen';
import RewardsScanProductScreen from 'src/components/elements/rewards/RewardsScanProductScreen';
import NewPickupTimeScreenNew from 'src/components/screens/orderAhead/NewPickupTimeScreen';
import NewPickupLocationScreenNew from 'src/components/screens/orderAhead/NewPickupLocationScreen';
import Menu from 'src/components/screens/orderAhead/MenuScreen';
import ScanAndPayScreenNewUI from 'src/components/screens/scanAndPay/ScanScreenNewUI';
import PurchaseReceiptScreen from 'src/components/screens/account/history/PurchaseHistoryDetailScreen';
import HomeScreenNew from 'src/components/screens/home/HomeScreen';
import SearchProductsScreen from 'src/components/screens/scanAndPay/SearchProductsScreen';
import RecentOrdersScreenNew from 'src/components/screens/orderAhead/RecentOrdersScreen';
import ProductDetailScreenNew from 'src/components/screens/orderAhead/ProductDetailScreen';
import InsufficientCreditScreen from 'src/components/screens/funding/InsufficientCreditScreen';
import ScanPay365ReceiptScreen from 'src/components/screens/account/history/ScanPay365ReceiptScreen';
import ShareReceiptScreen from 'src/components/screens/cart/ShareReceiptScreen';
import BunnDispenseScreen from 'src/components/screens/cart/coffee/BunnDispenseScreen';
import CardsScreen from 'src/components/screens/funding/CreditCardsScreen';
import DisclaimerScreen from 'src/components/screens/orderAhead/DisclaimerScreen';

const Stack = createStackNavigator();

const screens = [
  {name: AppRoutes.RewardsScreen, component: RewardsTabScreenWithHOC},
  {name: AppRoutes.ScanAccount, component: ScanAccountScreen},
  {name: AppRoutes.SnackDetail, component: SnackDetailScreen},
  {
    name: AppRoutes.NewMobileOrderLocation,
    component: NewMobileOrderLocationScreen,
  },
  {name: AppRoutes.RewardsScanProduct, component: RewardsScanProductScreen},
  {
    component: NewPickupTimeScreenNew,
    name: AppRoutes.NewPickupTime,
  },
  {
    component: NewPickupLocationScreenNew,
    name: AppRoutes.NewPickupLocation,
  },
  {name: AppRoutes.Menu, component: Menu},
  {
    name: AppRoutes.ScanAndPay,
    component: ScanAndPayScreenNewUI,
  },
  {
    name: AppRoutes.Scan,
    component: ScanAndPayScreenNewUI,
  },
  {
    component: PurchaseReceiptScreen,
    name: AppRoutes.PurchaseHistoryDetail,
  },
  {name: AppRoutes.NewHome, component: HomeScreenNew},
  {name: AppRoutes.SearchProducts, component: SearchProductsScreen},
  {
    component: RecentOrdersScreenNew,
    name: AppRoutes.RecentOrders,
  },
  {
    component: ProductDetailScreenNew,
    name: AppRoutes.ProductDetail,
  },
  {name: AppRoutes.InsufficientCredit, component: InsufficientCreditScreen},
  {name: AppRoutes.ScanPay365ReceiptScreen, component: ScanPay365ReceiptScreen},
  {name: AppRoutes.ShareReceipt, component: ShareReceiptScreen},
  {name: AppRoutes.BunnDispense, component: BunnDispenseScreen},
  {name: AppRoutes.Wallet, component: CardsScreen},
  {component: CardsScreen, name: AppRoutes.PDCards},
  {name: AppRoutes.Disclaimer, component: DisclaimerScreen},
];

export default function RewardsNavigator() {
  return (
    <Stack.Navigator
      initialRouteName={AppRoutes.RewardsScreen}
      screenOptions={{
        headerShown: false,
        presentation: 'transparentModal',
        cardStyle: {
          backgroundColor: 'transparent',
        },
        cardOverlayEnabled: true,
      }}
    >
      {screens.map(({name, component}) => (
        <Stack.Screen key={name} name={name} component={component} />
      ))}
    </Stack.Navigator>
  );
}
